import { ErrorBoundary } from "@sentry/react"

const Error = ({ children }) => {
  return (
    <ErrorBoundary
      fallback={<p>Something went wrong. Please try again later.</p>}
    >
      {children}
    </ErrorBoundary>
  )
}

export default Error